import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { setMeta } from '../utils/seo';

function Contact() {
  const [showQr, setShowQr] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
    setMeta({
      title: 'HHpoker客服中心｜下载、安装与账号问题咨询',
      description: '提供HHpoker客服咨询入口，覆盖下载异常、安装失败、证书信任、俱乐部加入及常见账号问题，支持快速定位与处理。',
      keywords: 'HHpoker客服, HHpoker联系客服, HHpoker客服入口, HHpoker下载问题咨询, HHpoker安装问题咨询',
      url: window.location.origin + '/contact/',
      robots: 'index,follow'
    });
  }, []);

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      
      {/* 侧边悬浮栏 */}
      <div style={{
        position: 'fixed',
        right: '20px',
        bottom: '100px',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        zIndex: 100
      }}>
        <button 
          onClick={() => setShowQr(true)}
          style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: '#efa765',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(239, 167, 101, 0.4)',
            transition: 'transform 0.2s',
          }}
          onMouseOver={e => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
        >
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a1c29" strokeWidth="2" strokeLinecap="round" strokeJoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><path d="M3 14h7v7H3z"></path></svg>
        </button>
      </div>

      {/* 二维码弹窗 */}
      {showQr && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.8)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(5px)'
        }} onClick={() => setShowQr(false)}>
          <div style={{
            background: '#fff',
            padding: '30px',
            borderRadius: '16px',
            textAlign: 'center',
            position: 'relative',
            maxWidth: '300px',
            width: '90%'
          }} onClick={e => e.stopPropagation()}>
            <button 
              onClick={() => setShowQr(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'transparent',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: '#333'
              }}
            >×</button>
            <h3 style={{color: '#333', marginBottom: '20px'}}>扫码添加好友</h3>
            <img src="/images/wechat_qr.png" alt="QR Code" style={{width: '100%', borderRadius: '8px'}} />
            <p style={{color: '#666', marginTop: '15px', fontSize: '0.9rem'}}>请使用微信/QQ扫一扫</p>
          </div>
        </div>
      )}

      <section className="hero-section contact-hero" style={{ 
        flex: 1,
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '120px 8vw 80px',
        textAlign: 'center',
        background: `linear-gradient(rgba(20,22,34,0.9), rgba(20,22,34,0.95)), url('/images/banner.jpg') center/cover no-repeat fixed`
      }}>
        
        <div data-aos="fade-down" style={{ maxWidth: '800px', margin: '0 auto 60px' }}>
          <h1 style={{ fontSize: '3rem', color: '#efa765', marginBottom: '24px', fontWeight: 800 }}>
             HHpoker 官方客服中心
          </h1>
          <p style={{ fontSize: '1.2rem', color: '#ccc', lineHeight: '1.8' }}>
            提供下载安装支持、账号问题协助与俱乐部合作对接<br/>
            可通过三条、QQ 等官方渠道快速联系人工客服
          </p>
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 450px))', 
          gap: '30px',
          maxWidth: '1000px',
          width: '100%',
          justifyContent: 'center'
        }}>
            
            <div data-aos="fade-up" style={{ 
              background: 'rgba(255,255,255,0.05)', 
              padding: '48px 32px', 
              borderRadius: '24px', 
              border: '1px solid rgba(239,167,101,0.15)',
              backdropFilter: 'blur(10px)',
              transition: 'transform 0.3s ease, border-color 0.3s ease',
              cursor: 'default'
            }}
            onMouseOver={e => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = 'rgba(239,167,101,0.5)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(239,167,101,0.15)';
            }}
            >
              <h2 style={{ color: '#efa765', marginBottom: '40px', fontSize: '1.8rem', fontWeight: 700 }}>客户服务</h2>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                <div style={{ display: 'flex', alignItems: 'center', padding: '16px', background: 'rgba(0,0,0,0.2)', borderRadius: '12px' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#efa765', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '20px', fontSize: '1.5rem', color: '#1a1c29' }}>
                    💬
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <p style={{ color: '#aaa', fontSize: '0.9rem', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '1px' }}>三条 账号</p>
                    <p style={{ color: '#fff', fontSize: '1.4rem', fontWeight: 'bold', fontFamily: 'monospace' }}>king33</p>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', padding: '16px', background: 'rgba(0,0,0,0.2)', borderRadius: '12px' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#efa765', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '20px', fontSize: '1.5rem', color: '#1a1c29' }}>
                    🐧
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <p style={{ color: '#aaa', fontSize: '0.9rem', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '1px' }}>QQ 客服</p>
                    <p style={{ color: '#fff', fontSize: '1.4rem', fontWeight: 'bold', fontFamily: 'monospace' }}>2222692</p>
                  </div>
                </div>
              </div>
            </div>

            <div data-aos="fade-up" data-aos-delay="100" style={{ 
              background: 'rgba(255,255,255,0.05)', 
              padding: '48px 32px', 
              borderRadius: '24px', 
              border: '1px solid rgba(239,167,101,0.15)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              flexDirection: 'column',
              // alignItems: 'center',
              // justifyContent: 'center',
              transition: 'transform 0.3s ease, border-color 0.3s ease'
              
            }}
            onMouseOver={e => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = 'rgba(239,167,101,0.5)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(239,167,101,0.15)';
            }}
            >
              <h2 style={{ color: '#efa765', marginBottom: '40px', fontSize: '1.8rem', fontWeight: 700 }}>商务合作</h2>
              
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '32px' }}>
                 <div style={{ display: 'flex', alignItems: 'center', padding: '16px', background: 'rgba(0,0,0,0.2)', borderRadius: '12px' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#efa765', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '20px', fontSize: '1.5rem', color: '#1a1c29' }}>
                    🤝
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <p style={{ color: '#aaa', fontSize: '0.9rem', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '1px' }}>Telegram</p>
                    <p style={{ color: '#fff', fontSize: '1.4rem', fontWeight: 'bold' }}>@example</p>
                  </div>
                 </div>
                 
                 <div style={{ padding: '20px', background: 'rgba(239, 167, 101, 0.1)', borderRadius: '12px', border: '1px dashed rgba(239, 167, 101, 0.3)' }}>
                    <p style={{ color: '#ddd', fontSize: '0.95rem', lineHeight: '1.6', margin: 0, textAlign: 'left' }}>
                      寻求战队入驻、流量合作或代理加盟？<br/>
                      欢迎通过上方 Telegram 与我们取得联系，我们将提供专业的合作方案。
                    </p>
                    <button 
                      onClick={() => setShowQr(true)}
                      style={{
                        marginTop: '16px',
                        width: '100%',
                        padding: '10px',
                        background: 'transparent',
                        border: '1px solid #efa765',
                        color: '#efa765',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '0.9rem'
                      }}
                    >
                      查看二维码
                    </button>
                 </div>
              </div>
            </div>

        </div>

      </section>

      <section style={{ padding: '28px 8vw 40px', background: '#1f2233' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ color: '#efa765', fontSize: '1.5rem', marginBottom: '12px' }}>客服常见问题</h2>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker怎么联系客服最快？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：通过本页客服入口提交，并一次性附上机型、系统版本和报错截图。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker客服能处理哪些问题？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：可处理下载异常、安装失败、证书信任、账号咨询与俱乐部相关问题。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：联系客服前需要准备什么信息？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：建议准备问题发生时间、复现步骤、截图和已尝试操作记录。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：俱乐部相关问题也在这里咨询吗？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：可以，俱乐部加入、ID匹配与常见规则问题均可在本页提交。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：提交后多久会有回复？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '0' }}>A：一般会先给初步处理建议，复杂问题会按流程继续跟进。</p>
        </div>
      </section>

      <footer style={{ background: '#0c0909', padding: '40px 8vw', borderTop: '1px solid #222', textAlign: 'center' }}>
        <p style={{ color: '#555', fontSize: '0.9rem' }}>Copyright © 2026 HHpoker. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default Contact;
